import xs from "xstream"
import {div, br, label, input, button, textarea} from "@cycle/dom"

export const view = granted$ => {
	return granted$ 
		.map(granted => {
			return div(".panel-body.panel-primary",[
				div(".form.col-sm-12",[
					div(".form-group",[
						label({attrs: {for: "policy"}}, ["【個人情報の取り扱い】"]),
							textarea(".form-control", {attrs: {readonly: true}},["本システムにてご入力頂く情報には、 会員の氏名、メールアドレスなどの個人情報が含まれます。この情報は業務委託内容に応じて使用するもので、ご入力頂いた個人情報を外部に公開したり、第三者に提供することはいたしません。本会に登録された個人情報の開示、および開示の結果当該情報が誤っている場合は、訂正または削除を要求する権利を会員は有します。"])
					]),
					div(".mt-2.ms-2",[
						label([
							input("#cbGranted",{attrs: {type:"checkbox",name:"granted",value:"1"}, props: {checked: granted}}),
							"上記に同意してサービスを利用する"
						])
					]),
					div(".mt-4.d-grid.col-md-4",[
						button("#btn2CreditForm.btn.btn-primary", {attrs: {type:"button"}, props: {disabled: !granted}},["サービスを利用する"])
					])
				])
			])
		})
}
